import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import upload from '../Res/Icon/Upload.png';
import deleteUpload from '../Res/Icon/file-delete.png';

function CustomDropzone(props) {

    const onDrop = useCallback(acceptedFiles => {
        console.log(acceptedFiles)
        onFileChange(acceptedFiles)
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
    const { files = [], onFileChange } = props;

    return (
        <>
            <div {...getRootProps()}>
                <input {...getInputProps()} />
                {
                    // if you want to change drop message
                    // isDragActive ?
                    //   <p>Drop the files here ...</p> :
                    <div>

                        {
                            !(files?.length > 0) &&
                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ flexDirection: 'column' }}
                            >
                                <img className="upload-icon" src={upload} alt="..." />
                                <p>
                                    Drag and drop PDF or Word file here or{' '}
                                    <span style={{ color: '#3b5aa9', fontWeight: '600' }}>Upload</span>
                                </p>
                            </div>
                        }
                    </div>
                }
            </div>
            <>
                {files.length > 0 && (
                    <img className="upload-icon" style={{ zIndex: 10 }} src={deleteUpload} alt="..." onClick={() => { onDrop(''); console.log('this is deleted') }} />
                )}
            </>
        </>
    )
}
export default CustomDropzone;